export function formatDollars(d: number | undefined): string {
  if (d == null) return "—";
  if (d < 0.01) return "<$0.01";
  if (d < 1) return `$${d.toFixed(3)}`;
  if (d < 100) return `$${d.toFixed(2)}`;
  return `$${Math.round(d).toLocaleString()}`;
}

export function formatDuration(ms: number | undefined): string {
  if (!ms || ms < 0) return "—";
  if (ms < 1000) return `${ms} ms`;
  const s = Math.round(ms / 100) / 10;
  if (s < 60) return `${s.toFixed(1)} s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s - m * 60);
  return `${m}m ${rem}s`;
}

export function formatTokens(n: number | undefined): string {
  if (n == null) return "—";
  if (n < 1000) return `${n}`;
  return `${(n / 1000).toFixed(1)}k`;
}
